export const MODAL_TRANSITION_DURATION = 300

const Modals = {
  MODAL_TRANSITION_DURATION,

  winX: null,
  winY: null,
  openedModals: {} as Record<string, { cleanup: () => void }>,

  init: () => {
    window.addEventListener("scroll", () => {
      // @ts-expect-error -- FIXME
      Modals.winX = window.scrollX
      // @ts-expect-error -- FIXME
      Modals.winY = window.scrollY
    })
  },

  /**
   * Opens a modal and optionally listens for interactions.
   *
   * If `actions` is provided, it should map action names (that is, the
   * contents of some button's data-action attribute) to a function that
   * will be called when the corresponding button is clicked.
   *
   * If `actions` has a value for the key 'dismiss', it will be run
   * when the user clicks outside the modal, before closing the modal.
   * If the dismiss handler calls preventDefault() on its event, the
   * modal will not be closed.
   */
  openModal(
    id: string,
    actions: { [k: string]: (event: Event) => any } = {},
    opt: { duration?: number } = {},
  ) {
    const duration = opt.duration ?? MODAL_TRANSITION_DURATION
    const modalElement = document.getElementById(id)
    // @ts-expect-error -- FIXME
    const acceptClickOutside = !("ignoreClickOutside" in modalElement.dataset)

    const onClickOutside = (e: Event) => {
      if (
        acceptClickOutside &&
        // @ts-expect-error -- FIXME
        !modalElement.querySelector(".modal-content").contains(e.target)
      ) {
        actions.dismiss?.(e)
        if (!e.defaultPrevented) Modals.closeModal(id)
      }
    }
    // @ts-expect-error -- FIXME
    modalElement.addEventListener("click", onClickOutside)

    const actionCleanups = Object.entries(actions).map(
      ([actionName, callback]) => {
        const buttons = [
          // @ts-expect-error -- FIXME
          ...modalElement.querySelectorAll(`button[data-action=${actionName}]`),
        ]
        for (const button of buttons) {
          button.addEventListener("click", callback, true)
        }
        return () => {
          for (const button of buttons) {
            button.removeEventListener("click", callback, true)
          }
        }
      },
    )

    const cleanup = () => {
      // @ts-expect-error -- FIXME
      modalElement.removeEventListener("click", onClickOutside)
      actionCleanups.forEach((f) => f())
    }

    Modals.openedModals[id] = { cleanup }
    // @ts-expect-error -- FIXME
    modalElement.classList.add("show")
    // @ts-expect-error -- FIXME
    modalElement.style.transitionDuration = `${duration}ms`
    Modals.scrollToTop(modalElement)

    setTimeout(() => {
      const modal = document.getElementById(id)
      // @ts-expect-error -- FIXME
      modal.querySelector("[autofocus]")?.focus?.()
    })

    return modalElement as HTMLElement
  },

  /**
   * Closes the modal with id `id`, and returns a Promise
   * that will be fulfilled once the modal is fully closed
   * (that is, once the animated transition is complete)
   */
  closeModal(id: string, opt: { duration?: number } = {}) {
    const duration = opt.duration ?? MODAL_TRANSITION_DURATION
    const modal = Modals.openedModals[id]
    if (!modal) return Promise.resolve()
    return new Promise((ok) => {
      modal.cleanup()
      delete Modals.openedModals[id]
      const elem = document.getElementById(id)
      // @ts-expect-error -- FIXME
      elem.classList.add("hiding")
      // @ts-expect-error -- FIXME
      elem.style.transitionDuration = `${duration}ms`
      setTimeout(() => {
        // @ts-expect-error -- FIXME
        elem.classList.remove("show", "hiding")
        // @ts-expect-error -- FIXME
        ok()
      }, duration)
      const remainingOpenModals = document.querySelectorAll(".modal.show")
      if (remainingOpenModals.length === 0) {
        // @ts-expect-error -- FIXME
        document.querySelector("body").classList.remove("no-scroll")
      }
    })
  },

  openModalAndFocusField: (modalId: string, fieldId: string) => {
    Modals.openModal(modalId)
    setTimeout(() => {
      const field = document.getElementById(fieldId)
      // @ts-expect-error -- FIXME
      field.focus()
      // @ts-expect-error -- FIXME
      field.selectionStart = field.value.length
      // @ts-expect-error -- FIXME
      field.selectionEnd = field.value.length
    })
  },
  openFullModal: (id: string) => {
    const modalElement = document.getElementById(id)
    // @ts-expect-error -- FIXME
    modalElement.classList.add("show")
    document.body.style.overflow = "hidden"
    Modals.scrollToTop(modalElement)
  },
  closeFullModal: (id: string) => {
    document.body.style.overflow = "initial"
    // @ts-expect-error -- FIXME
    window.scrollX = Modals.winX
    // @ts-expect-error -- FIXME
    window.scrollY = Modals.winY
    // @ts-expect-error -- FIXME
    document.getElementById(id).classList.remove("show")
  },
  scrollToTop: (modalElement: HTMLElement | null) => {
    if (!modalElement) return
    const scrollElement = modalElement.querySelector<HTMLElement>(".modal-body")
    if (scrollElement) {
      scrollElement.scrollTop = 0
    }
  },
  scrollToBottom: (modalElement: Element) => {
    const scrollElement = modalElement.querySelector<HTMLElement>(".modal-body")
    scrollElement?.scrollTo(0, scrollElement.scrollHeight)
  },
}

// expose globally available functions
window.openModal = Modals.openModal
// @ts-expect-error -- FIXME
window.openModalAndFocusField = Modals.openModalAndFocusField
// @ts-expect-error -- FIXME
window.closeModal = Modals.closeModal
// @ts-expect-error -- FIXME
window.openFullModal = Modals.openFullModal
window.closeFullModal = Modals.closeFullModal

export default Modals
